export type BrandKey = "irondew" | "kveja";

export type HostContext = {
  brand: BrandKey;
  brandName: string;
  storagePrefix: string;
  themeLinkId: string;
  documentTitle: string;
  mockEmailDomain: string;
};

const BRAND_HOST_PATTERNS: Record<BrandKey, RegExp[]> = {
  kveja: [/(^|\.)kveja(\.|$)/],
  irondew: [/(^|\.)irondew(\.|$)/]
};

const BRAND_CONFIGS: Record<BrandKey, HostContext> = {
  kveja: {
    brand: "kveja",
    brandName: "KVEJA",
    storagePrefix: "kveja",
    themeLinkId: "kveja-theme-css",
    documentTitle: "KVEJA Mail",
    mockEmailDomain: "kveja.com"
  },
  irondew: {
    brand: "irondew",
    brandName: "IronDew",
    storagePrefix: "irondew",
    themeLinkId: "irondew-theme-css",
    documentTitle: "IronDew Webmail",
    mockEmailDomain: "irondew.com"
  }
};

function getHostname(): string {
  return window.location.hostname.toLowerCase();
}

function getBrandFromHost(host: string): BrandKey {
  const entries = Object.entries(BRAND_HOST_PATTERNS) as [BrandKey, RegExp[]][];
  for (const [brand, patterns] of entries) {
    if (patterns.some((pattern) => pattern.test(host))) {
      return brand;
    }
  }
  return "kveja";
}

export function getHostContext(): HostContext {
  const forced = import.meta.env.VITE_BRAND as BrandKey | undefined;
  if (forced && BRAND_CONFIGS[forced]) {
    return BRAND_CONFIGS[forced];
  }

  const host = getHostname();
  const brand = getBrandFromHost(host);
  return BRAND_CONFIGS[brand];
}
